// Инвариант «Отъездила» ⇒ ride (api: Booking#rided_state_requires_return, бронирование 712517, 2026-10-06).
// Статус «Отъездила» значит «объект вернули». Без приёмки (ride) бронирование
// застревает: выдача отвечает 409 booking_already_returned, приёмка — 409.
// Статус ставит только приёмка («Принять объект»), поэтому каждый экран смены
// статуса проверяет переход до запроса и объясняет причину; сервер отвечает
// тем же отказом (booking_not_returned) — на старых бандлах и прямых вызовах.
export const RIDED_STATE = "Отъездила";

// Бронирование уже отъездило: выдача его не выдаст (api Issue#returned?).
export function isReturnedBooking(booking) {
  return !!booking && (!!booking.ride || booking.state === RIDED_STATE);
}

// Переход в «Отъездила» без приёмки. Бронирование, которое уже стоит в
// «Отъездила» (старые данные), — не переход: сервер его сохранение пропускает.
// Неизвестное бронирование не блокируется — решит сервер. Бронирование
// договора выкупа (rent_to_own) — тоже: у действующего договора отказ сервера
// свой и приоритетнее (managed_by_contract — «управляет договор», а не «примите
// объект»), а закрыт ли договор, строка списка не знает.
export function blocksRidedState(booking, nextState) {
  return !!booking && !isRentToOwnBooking(booking) && nextState === RIDED_STATE && !booking.ride && booking.state !== RIDED_STATE;
}

// Бронирование договора выкупа: rent_to_own отдают сериализаторы, а cable-обновления
// (календарь — BroadcastTimelineJob) шлют сырую запись без него, но с колонкой
// rent_to_own_contract_id.
function isRentToOwnBooking(booking) {
  return !!booking.rent_to_own || (booking.rent_to_own_contract_id !== undefined && booking.rent_to_own_contract_id !== null);
}

// Отказ с причиной — один текст для всех экранов (bookings.rided_requires_return).
// true — переход заблокирован и пользователю объяснено, запрос слать не надо.
export function refuseRidedState(vm, booking, nextState) {
  if (!blocksRidedState(booking, nextState)) return false;
  vm.$notify(vm.$t("errors.update_state"), vm.$t("bookings.rided_requires_return"), "warning", 10000);
  return true;
}

// Бронирование по id из всех списков экрана: экраны держат строки в разных
// массивах по режиму (календарь — bookings / all_bookings; список —
// active / inactive / rided / part_return_deposit). Не найдено — undefined.
export function findBookingIn(id, ...lists) {
  for (const list of lists) {
    const found = (list || []).find((b) => b && b.id === id);
    if (found) return found;
  }
  return undefined;
}
